import React, {lazy, useState} from "react";

// React.lazy plus .preload(), which fetches the page's code ahead of time. A lazy page always suspends the first time
// it draws, even when its code is already here, which flashes the nearest loading spinner; once preloaded, this one
// draws straight away instead.
export default function lazyWithPreload(load) {
    let Loaded = null;
    let loading = null;
    const preload = () => {
        loading = loading || load().then(module => {
            Loaded = module.default;
            return module;
        }, error => {
            // Let a later attempt try again
            loading = null;
            throw error;
        });
        return loading;
    };
    const LazyPage = lazy(preload);

    function Page(props) {
        // Chosen once per mount, so the page never switches between the two (that would remount it and lose its state)
        const [ReadyPage] = useState(() => Loaded);
        return ReadyPage ? <ReadyPage {...props}/> : <LazyPage {...props}/>;
    }

    Page.preload = preload;
    return Page;
}
